import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@material-ui/core';
import { toast } from 'react-toastify';
import { AccountMaxPostPublished } from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import Colours from '../../styles/colours';
import Loading from '../../components/global/OverLoading';
import ApiService from '../../services.js/apiService';

function Overview(props) {
  const [data, setData] = useState({});
  const [loading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    await ApiService.getBusinessAccounts({ pageId: props.pageId })
      .then((res) => {
        if (!IsEmpty(res.rows)) {
          setData(res.rows[0]);
        } else {
          toast.error('This page does not exist.');
        }
      })
      .catch((error) => {
       toast.error(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="p-2">

        <div className="mt-4">
          <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>Page Id</Typography>
          <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}><Link href={`/admin/page/${data.pageId}`} target="_blank">{data.pageId}</Link></Typography>
        </div>

        <hr />

        <div className="mt-4">
          <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>Page Name</Typography>
          <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>{data.pageName}</Typography>
        </div>

        <hr />

        <div className="mt-4">
          <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>Acount Plan</Typography>
          <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>{data.plan}</Typography>
        </div>

        <hr />

        <div className="mt-4">
          <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>No. of Staff</Typography>
          <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>{data.noOfStaff}</Typography>
        </div>

        <hr />

        <div className="mt-4">
          <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>Monthly Live Post(s) Published / Limit</Typography>
          <Typography className="mt-1" variant="body1" color="inherit" style={{ color: Colours.Black }}>
            {`${data.postsPublished} of ${AccountMaxPostPublished[data.plan]}`}
          </Typography>
        </div>

      </div>
    </>
  );
}

Overview.defaultProps = {
};

Overview.propTypes = {
  pageId: PropTypes.number.isRequired,
};

export default Overview;
